import { Injectable } from '@angular/core';

import { AppConfig } from '../app.config';
import { throwError } from 'rxjs';
import { filter, map, catchError } from 'rxjs/operators';
import { HelpersService } from './helpers.service';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { ErrorHandlerService } from './errorhandler.service';// Add this for error feedback
 
@Injectable({
  providedIn: 'root',
})
export class InventoryService {
  private env: any;

  constructor(
    private http: HttpClient,
    private httpClient: HttpClient,
    private appConfig: AppConfig,
    private helpersService: HelpersService, 
    private errorHandler: ErrorHandlerService,// Add this for error feedback
  ) {
    this.env = this.appConfig.getEnvironmentNew();
  }

  getInventoryAudit(partnerID, page, limit, skusearch, jobcardno = '') {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          `/Bikeshop/Inventory/Audit/${partnerID}?page=${page}&limit=${limit}&skusearch=${skusearch}&jobcardno=${jobcardno}&code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getInventorySummary(partnerID, page, limit, search) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          `/Bikeshop/Inventory/Summary/${partnerID}?page=${page}&limit=${limit}&search=${search}&code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateHubtigerInventoryBalance(partnerID, data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
          `/Bikeshop/Inventory/CorrectHubtigerBalance/${partnerID}?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => res),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  updateLightSpeedInventoryBalance(partnerID, data) {
    const headers = new HttpHeaders()
      .set('content-type', 'application/json')
      .set('Access-Control-Allow-Origin', '*')
      .set(
        'Authorization',
        `Bearer ${this.helpersService.getAuthDataNew().token}`,
      );

    return this.httpClient
      .post(
        this.env.url +
          `/Bikeshop/Inventory/CorrectLightSpeedBalance/${partnerID}?code=${this.env.key}`,
        data,
        { headers: headers },
      )
      .pipe(
        map((res) => res),
        catchError((error: HttpErrorResponse) => {
          return throwError(error);
        }),
      );
  }

  addBackStockFromQuote(partnerID, serviceID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
          `/Bikeshop/Inventory/ReBalanceLightSpeedInventory/${partnerID}/${serviceID}?code=${this.env.key}`,
        {},
        headers,
      )
      .pipe(
        map((res: any) => res),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }
}
